module.exports = __webpack_public_path__ + "assets/c06e32fa21f1b8cf9c3c710c2a5cdd06.mp4";